import { assign, entryId, validNumber } from "../../helper.js";
import { Direction, DirectionList, ReferentialAction, ReferentialActionList, RelationshipType, RelationshipTypeList, StartRelationshipType, StartRelationshipTypeList } from "../schema/relationship.entity.js";
import { isBoolean, isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/relationship.entity.js
var createRelationship = () => ({
	id: "",
	identification: false,
	relationshipType: RelationshipType.ZeroN,
	startRelationshipType: StartRelationshipType.dash,
	onDelete: ReferentialAction.none,
	onUpdate: ReferentialAction.none,
	start: {
		tableId: "",
		columnIds: [],
		x: 0,
		y: 0,
		direction: Direction.bottom
	},
	end: {
		tableId: "",
		columnIds: [],
		x: 0,
		y: 0,
		direction: Direction.bottom
	}
});
function createAndMergeRelationshipEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createRelationship();
		assign(isString, target, value);
		const assignBoolean = assign(isBoolean, target, value);
		const startAssignNumber = assign(isNumber, target.start, value.start);
		const startAssignString = assign(isString, target.start, value.start);
		const endAssignNumber = assign(isNumber, target.end, value.end);
		const endAssignString = assign(isString, target.end, value.end);
		target.id = entryId(key, value);
		assignBoolean("identification");
		assign(validNumber(RelationshipTypeList), target, value)("relationshipType");
		assign(validNumber(StartRelationshipTypeList), target, value)("startRelationshipType");
		assign(validNumber(ReferentialActionList), target, value)("onDelete");
		assign(validNumber(ReferentialActionList), target, value)("onUpdate");
		startAssignString("tableId");
		startAssignNumber("x");
		startAssignNumber("y");
		assign(validNumber(DirectionList), target.start, value.start)("direction");
		assign(Array.isArray, target.start, value.start)("columnIds");
		endAssignString("tableId");
		endAssignNumber("x");
		endAssignNumber("y");
		assign(validNumber(DirectionList), target.end, value.end)("direction");
		assign(Array.isArray, target.end, value.end)("columnIds");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeRelationshipEntities, createRelationship };
